import { Typography } from "@mui/material";
import { HostSystemItemView } from "@tlc/ls2pac/dto/HostSystemItemView";
import * as React from "react";
import { useLanguage } from "../../Language";

export const GenreDisplay = ({ loan }: { loan: HostSystemItemView }) => {
  const { translate } = useLanguage();
  const { collection } = loan;

  if (collection?.length > 0) {
    return (
      <Typography component={"h4"} variant={"subtitle2"}>
        {translate("genre")}: {collection}
      </Typography>
    );
  }

  return null;
};
